import type { Tier } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (tier?: Tier, countSuggestedCareerPaths?: number) => {
  useRegisterAgentContext({
    kind: 'visual',
    label: 'Calibrating Blueprint Animation',
    display:
      'Animated loading screen with a progress bar that fills over 5 seconds while the blueprint is generated, then advances the user to their blueprint.',
    data: {
      tier: tier ?? null,
      suggestedCareerPathCount: countSuggestedCareerPaths ?? null,
    },
  });
};
